import { TypedDocumentNode, gql } from '@apollo/client';

import { ScoreStatus } from '__generated__/globalTypes';
import { isType } from 'lib/gql';

import { Score } from '../Score';
import type { PlayerGameScoreScore_playerGameScoreInterface } from './__generated__/index.graphql';

type Props = {
  playerGameScore?: PlayerGameScoreScore_playerGameScoreInterface;
  shape?: 'TEXT' | 'PILL';
  size?: 3 | 4;
  hidePending?: boolean;
};

export const PlayerGameScoreScore = ({
  playerGameScore,
  shape = 'PILL',
  size = 4,
  hidePending,
}: Props) => {
  const { score, scoreStatus, anyPlayerGameStats } = playerGameScore || {};

  return (
    <Score
      hideReviewing
      shape={shape}
      score={score || 0}
      scoreStatus={
        typeof score === 'number' && scoreStatus
          ? scoreStatus
          : ScoreStatus.DID_NOT_PLAY
      }
      hidePending={hidePending}
      scoreType="PLAYER_SCORE"
      animated={false}
      size={size}
      fieldStatus={
        (isType(anyPlayerGameStats, 'PlayerGameStats') &&
          anyPlayerGameStats.fieldStatus) ||
        undefined
      }
    />
  );
};

PlayerGameScoreScore.fragments = {
  playerGameScoreInterface: gql`
    fragment PlayerGameScoreScore_playerGameScoreInterface on PlayerGameScoreInterface {
      id
      score
      scoreStatus
      anyGame {
        id
        status: statusTyped
      }
      anyPlayerGameStats {
        id
        ... on PlayerGameStats {
          id
          fieldStatus
        }
      }
    }
  ` as TypedDocumentNode<PlayerGameScoreScore_playerGameScoreInterface>,
};
